import { render, staticRenderFns } from "./AppThemes.vue?vue&type=template&id=04c9e0d9"
import script from "./AppThemes.vue?vue&type=script&lang=ts"
export * from "./AppThemes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports